import type { SVGProps } from "react";
const SenecPictogramLivingQuarters = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M23 29C23 28.4477 23.4477 28 24 28H25C25.5523 28 26 28.4477 26 29C26 29.5523 25.5523 30 25 30H24C23.4477 30 23 29.5523 23 29Z"
            fill="currentColor"
        />
        <path
            d="M23 34C23 33.4477 23.4477 33 24 33H25C25.5523 33 26 33.4477 26 34C26 34.5523 25.5523 35 25 35H24C23.4477 35 23 34.5523 23 34Z"
            fill="currentColor"
        />
        <path
            d="M35 14C35.5523 14 36 14.4477 36 15V18C36 18.5523 35.5523 19 35 19C34.4477 19 34 18.5523 34 18V15C34 14.4477 34.4477 14 35 14Z"
            fill="currentColor"
        />
        <path
            d="M35 21C35.5523 21 36 21.4477 36 22V25C36 25.5523 35.5523 26 35 26C34.4477 26 34 25.5523 34 25V22C34 21.4477 34.4477 21 35 21Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42 5.5V39H32V42H30V39H14V42H12V39H6V35C6 34.4477 6.44772 34 7 34C7.55228 34 8 34.4477 8 35V37H12V35.874C10.2748 35.4299 9 33.8638 9 32C9 29.7909 10.7909 28 13 28C15.2091 28 17 29.7909 17 32C17 33.8638 15.7252 35.4299 14 35.874V37H19V11H8V30C8 30.5523 7.55228 31 7 31C6.44772 31 6 30.5523 6 30V9H21V25H28V11.3333L42 5.5ZM30 27H21V37H30V35.874C28.2748 35.4299 27 33.8638 27 32C27 30.1362 28.2748 28.5701 30 28.126V27ZM32 28.126V25H30V12.6667L40 8.5V37H32V35.874C33.7252 35.4299 35 33.8638 35 32C35 30.1362 33.7252 28.5701 32 28.126ZM13 30C11.8954 30 11 30.8954 11 32C11 33.1046 11.8954 34 13 34C14.1046 34 15 33.1046 15 32C15 30.8954 14.1046 30 13 30ZM31 30C29.8954 30 29 30.8954 29 32C29 33.1046 29.8954 34 31 34C32.1046 34 33 33.1046 33 32C33 30.8954 32.1046 30 31 30Z"
            fill="currentColor"
        />
        <path
            d="M10 15C10 14.4477 10.4477 14 11 14H16C16.5523 14 17 14.4477 17 15C17 15.5523 16.5523 16 16 16H11C10.4477 16 10 15.5523 10 15Z"
            fill="currentColor"
        />
        <path
            d="M10 20C10 19.4477 10.4477 19 11 19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H11C10.4477 21 10 20.5523 10 20Z"
            fill="currentColor"
        />
        <path
            d="M10 25C10 24.4477 10.4477 24 11 24H16C16.5523 24 17 24.4477 17 25C17 25.5523 16.5523 26 16 26H11C10.4477 26 10 25.5523 10 25Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramLivingQuarters;
